// removed by extract-text-webpack-plugin
module.exports = {"chartCard":"antd-pro-chartCard","meta":"antd-pro-meta","action":"antd-pro-action","total":"antd-pro-total","content":"antd-pro-content","contentFixed":"antd-pro-contentFixed","footer":"antd-pro-footer"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/ChartCard/index.less
// module id = 398
// module chunks = 0 1